import { defineStore } from 'pinia';
import CommonError from '@/common/utils/errors/CommonError';
import { store } from '@/common/root';

interface Feature {
  id: string,
  enabled: boolean,
  title: string,
  description: string,
  metadata?: {
    target: 'common' | 'self-service' | 'hci'
  }
}

export const useFeaturesStore = defineStore('features', {
  state: () => ({
    features: <Feature[]>[]
  }),
  getters: {
    availableFeatures: state => state.features.filter(feature => !feature.metadata?.target
      || feature.metadata.target === 'common'
      || feature.metadata.target === APP_BUILD),
    findFeature() {
      return featureId => this.availableFeatures.find(feature => feature.id === featureId);
    }
  },
  actions: {
    async fetchFeatureConfig() {
      try {
        const res: FetchResponse<{ features: Feature[] }> = await store.$api.get('/features.json');
        this.features = res.data.features;
      } catch (err) {
        // Features config may absent, or contain an error.
        // Notify but do not block the application
        if (err instanceof CommonError) {
          console.error('Error while reading features.json file: ', err);
        }
        return err;
      }
      return Promise.resolve();
    },
  }
});

export default useFeaturesStore;
